"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGTMLoggedIn = setGTMLoggedIn;
exports.setGTMLoggedOut = setGTMLoggedOut;
require("core-js/modules/es.array.push.js");
function pushToDataLayer(payload) {
  if (window.analytics && window.dataLayer) {
    window.dataLayer.push(payload);
  }
}

/**
 *
 */
function setGTMLoggedIn() {
  pushToDataLayer({
    LoginStatus: 'Logged In'
  });
}

/**
 *
 */
function setGTMLoggedOut() {
  pushToDataLayer({
    LoginStatus: 'Not Logged In'
  });
}